var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6143,
    cy: 23.4414,
    rx: 24.3878,
    ry: 23.4394,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1768 14.7597C19.6891 14.8243 18.3996 15.1741 17.3584 16.1713C16.3135 17.1738 15.9543 18.4189 15.887 19.8349C15.8452 20.7187 15.6006 27.3955 16.3099 29.1465C16.7882 30.3278 17.7303 31.2361 18.9698 31.6976C19.5481 31.914 20.2083 32.0604 21.1768 32.1032C29.2748 32.4556 32.2766 32.2637 33.5425 29.1465C33.7671 28.5916 33.9217 27.9572 33.9644 27.028C34.3346 19.2196 33.9044 17.5271 32.4931 16.1713C31.3737 15.0973 30.0569 14.3663 21.1768 14.7597ZM21.2514 30.5328C20.3647 30.4944 19.8837 30.3523 19.5627 30.2328C18.7552 29.9309 18.1486 29.3499 17.8367 28.5778C17.2965 27.2473 17.4757 20.9282 17.5239 19.9057C17.5712 18.9041 17.7821 17.9887 18.5169 17.2821C19.4263 16.4096 20.6012 15.982 28.6009 16.3293C29.6449 16.3746 30.5989 16.5771 31.3354 17.2821C32.2448 18.1545 32.6959 19.2932 32.3285 26.9576C32.2885 27.8083 32.1402 28.2699 32.0157 28.5778C31.1927 30.6063 29.2993 30.8879 21.2514 30.5328ZM28.6892 18.7739C28.6892 19.3515 29.1775 19.8211 29.7804 19.8211C30.3833 19.8211 30.8726 19.3515 30.8726 18.7739C30.8726 18.1964 30.3833 17.7271 29.7804 17.7271C29.1775 17.7271 28.6892 18.1964 28.6892 18.7739ZM20.2565 23.431C20.2565 25.9053 22.3472 27.9113 24.9262 27.9113C27.5052 27.9113 29.5958 25.9053 29.5958 23.431C29.5958 20.9568 27.5052 18.952 24.9262 18.952C22.3472 18.952 20.2565 20.9568 20.2565 23.431ZM21.8952 23.431C21.8952 21.8257 23.252 20.5233 24.9262 20.5233C26.6003 20.5233 27.9571 21.8257 27.9571 23.431C27.9571 25.0372 26.6003 26.34 24.9262 26.34C23.252 26.34 21.8952 25.0372 21.8952 23.431Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterInstagram);
export default __webpack_public_path__ + "static/media/Footer-Instagram.8d6fe4cb9e35098bfe495668387bd211.svg";
export { ForwardRef as ReactComponent };